import React from 'react'

const ValidationRules = () => {
  return (
    <div>ValidationRules</div>
  )
}

export default ValidationRules